// extracted by mini-css-extract-plugin
module.exports = {"Logo":"Logo_Logo__mYKvL","Logo_heading":"Logo_Logo_heading__SP9GI","Logo_asset":"Logo_Logo_asset__3E5iZ"};